export default function LegalBanner() {
  return (
    <aside data-testid="legal-banner" className="bg-slate-900 text-slate-300 px-4 py-2 text-xs border-b border-slate-800">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full bg-emerald-400"></span>
          <span><strong>Independent Consumer Tool:</strong> Educational financial estimates, not a credit offer or lending decision.</span>
        </div>
        <div className="text-slate-400 text-[11px]">Educational estimates only · Not a lending decision</div>
      </div>
    </aside>
  );
}
